<template>
  <v-card
    class="overflow-hidden pb-0"
    elevation="0"
    min-width="1170"
  >
    <v-app-bar
      class="default-reply-header"
      absolute
      color="white"
      height="93"
      elevate-on-scroll
      scroll-target="#default-reply-form"
    >
      <BreadCrumbs
        :breadcrumbs="defaultReplyBreadcrumbs"
        class="ma-0"
      />
      <v-btn
        class="text-body-2 ml-auto mr-3 cancel-btn"
        width="137"
        height="32"
        outlined
        depressed
        color="neutral-045"
        @click="openCheckModal('cancel')"
      >
        {{ $t('CANCEL') }}
      </v-btn>
      <v-btn
        class="text-body-2"
        width="137"
        height="32"
        dark
        depressed
        color="primary-001"
        :loading="isSubmitLoading"
        @click="pageStatus==='create'? createDefaultReply() : updateDefaultReply()"
      >
        {{ pageStatus==='create' ? $t('CREATE') : $t('SAVE') }}
      </v-btn>
    </v-app-bar>
    <v-sheet
      id="default-reply-form"
      class="overflow-y-auto mt-43 default-reply-warp"
      max-height="calc(100vh - 43px)"
    >
      <div class="mb-12">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <div class="d-flex justify-space-between">
            <div class="content-col">
              <Input
                v-model.trim="temp.title"
                :label="$t('DEFAULT_REPLY.TITLE')"
                :placeholder="$t('DEFAULT_REPLY.PLEASE_ADD_THE_TITLE')"
                validate-on-blur
                required
                :rules="[(v) => !!v || this.$t('DEFAULT_REPLY.THIS_FIELD_IS_REQUIRED')]"
                class="default-reply-title"
                hide-details="auto"
              />

              <div>
                <v-subheader
                  class="pa-0 mb-4"
                >
                  <label
                    class="neutral-042--text text-body-2"
                  >{{ $t('DEFAULT_REPLY.MESSAGE_COUNT') }}</label>
                  <span class="secondary-014--text text-body-2 ml-1">{{ messagesTotal }}/5</span>
                </v-subheader>
              </div>
              <v-subheader
                class="pa-0"
              >
                <label class="neutral-cold-051--text text-body-3">{{ $t('DEFAULT_REPLY.CONTENT') }}</label>
              </v-subheader>
              <TextareaEditor
                v-model.trim="temp.content"
                textarea-id="saveReplyMessage"
                :placeholder="disabledContentInput ? $t('DEFAULT_REPLY.MESSAGE_COUNT_UPPER_LIMIT_PLACEHOLDER'):$t('DEFAULT_REPLY.PLEASE_ADD_THE_CONTENT')"
                :disabled="disabledContentInput"
                rows="5"
                counter
                maxlength="1000"
                :variables="[
                  {
                    title: $t('DEFAULT_REPLY.CUSTOMER_NAME'),
                    name: 'system:customer_name'
                  }
                ]"
              />
              <div class="photo-container">
                <v-subheader
                  class="pa-0 photo-title"
                >
                  <label
                    class="neutral-cold-051--text text-body-3"
                  >{{ $t('DEFAULT_REPLY.IMAGE_OR_VIDEO') }}</label>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        class="ml-1"
                        size="18"
                      >
                        $vuetify.icons.infoIcon
                      </v-icon>
                    </template>
                    <p class="mb-0">
                      {{ $t('DEFAULT_REPLY.UPLOAD_INFO') }}
                    </p>
                    <p class="mb-0">
                      {{ $t('DEFAULT_REPLY.IMAGE_LIMIT_INFO') }}
                    </p>
                    <p class="mb-0">
                      {{ $t('DEFAULT_REPLY.VIDEO_LIMIT_INFO') }}
                    </p>
                  </v-tooltip>
                </v-subheader>
                <v-row class="photo-row">
                  <v-col
                    v-for="(media, index) in mediaList"
                    :key="media.url"
                    cols="4"
                    class="px-2"
                  >
                    <v-card
                      class="image-card"
                      elevation="0"
                    >
                      <component
                        :is="getMediaComponent(media.mediaType)"
                        :img-url="media.url"
                        :video-url="media.url"
                        :media-url="media.url"
                        @update-media="(media) => updateMedia(media ,index)"
                        @delete-media="deleteMediaItem(index)"
                      />
                    </v-card>
                  </v-col>
                  <v-col
                    cols="4"
                    class="px-2"
                  >
                    <DragPhoto
                      v-if="!isHideUploadInput"
                      class="drag-photo"
                      :text-color="'neutral-043--text'"
                      :image-size="5"
                      :video-size="16"
                      @new-upload-img="addImgUrl"
                      @new-upload-media="addMedia"
                    >
                      <template v-slot:text>
                        <div>
                          {{ $t('STICKER_PACK.DRAG_AND_DROP_IMAGE_HERE') }}
                        </div>
                      </template>
                    </DragPhoto>
                  </v-col>
                </v-row>
              </div>
              <!-- :img-url.sync="noPrizeSetting.image" -->
            </div>
            <div class="content-col">
              <v-subheader
                class="pa-0"
              >
                <label
                  for="selection"
                  class="neutral-cold-051--text text-body-3"
                >{{ $t('DEFAULT_REPLY.APPLY_TO') }}</label>
              </v-subheader>
              <div class="target-radio-box">
                <v-radio-group
                  v-model="temp.target"
                >
                  <v-radio
                    v-show="isShowRoleRadio"
                    :label="$t('DEFAULT_REPLY.ALL_MEMBERS')"
                    :value="1"
                    class="custom-radio"
                    on-icon="$vuetify.icons.radioIcon"
                    off-icon="$vuetify.icons.radioFalseIcon"
                  />
                  <v-radio
                    :label="$t('DEFAULT_REPLY.ONLY_ME')"
                    :value="2"
                    class="custom-radio"
                    on-icon="$vuetify.icons.radioIcon"
                    off-icon="$vuetify.icons.radioFalseIcon"
                  />
                  <v-radio
                    v-show="isShowRoleRadio"
                    :label="$t('DEFAULT_REPLY.SPECIFIC_ROLE')"
                    :value="3"
                    class="custom-radio"
                    on-icon="$vuetify.icons.radioIcon"
                    off-icon="$vuetify.icons.radioFalseIcon"
                  />
                  <MultiAutoComplete
                    :placeholder="$t('DEFAULT_REPLY.CHOOSE_SPECIFIC_ROLE')"
                    v-show="temp.target === 3"
                    v-model="roleSelect"
                    :items="roleList"
                    :rules="temp.target === 3 ? [comboboxRule]: []"
                    item-text="title"
                    item-value="value"
                    class="target-radio-auto-complete mb-3"
                    hide-details="auto"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            class="text-body-2 font-weight-medium grey--text text--darken-2"
                          >
                            {{ $t('DEFAULT_REPLY.NO_MATCH_SPECIFIC_ROLE') }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </MultiAutoComplete>
                  <v-radio
                    v-show="currentUserDict.enableOmo"
                    :label="$t('DEFAULT_REPLY.SPECIFIC_SHOP')"
                    :value="4"
                    class="custom-radio"
                    on-icon="$vuetify.icons.radioIcon"
                    off-icon="$vuetify.icons.radioFalseIcon"
                  />
                  <MultiAutoComplete
                    :placeholder="$t('DEFAULT_REPLY.CHOOSE_SPECIFIC_SHOP')"
                    v-show="temp.target === 4"
                    v-model="locationSelect"
                    :items="shopLocationList"
                    :rules="temp.target === 4 ? [comboboxRule]: []"
                    item-text="locationName"
                    item-value="locationCode"
                    class="target-radio-auto-complete mb-3"
                    hide-details="auto"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            class="text-body-2 font-weight-medium grey--text text--darken-2"
                          >
                            {{ $t('DEFAULT_REPLY.NO_MATCH_SPECIFIC_SHOP') }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </MultiAutoComplete>
                </v-radio-group>
              </div>
              <LabelsComboBox
                :labels="labels"
                :label="$t('DEFAULT_REPLY.LABELS')"
                :placeholder="$t('DEFAULT_REPLY.ADD_A_LABEL')"
                @combobox-input-change="updateLabels"
                class="labels-combo-box"
              />
            </div>
          </div>
        </v-form>
      </div>
    </v-sheet>
    <Modal
      ref="checkModal"
      :disable-overlay-click="modalType !== 'cancel'"
    >
      <template v-slot:actions>
        <v-card-actions class="pa-0 pt-8">
          <v-spacer />

          <template v-if="modalType === 'cancel'">
            <v-btn
              color="neutral-045"
              outlined
              @click="$refs.checkModal.closeModal();"
              class="text-body-2 cancel-btn"
            >
              {{ $t('CANCEL') }}
            </v-btn>
            <v-btn
              color="danger-022"
              outlined
              @click="closeModalAndLeave"
              class="text-body-2 ml-3"
            >
              {{ $t('LEAVE') }}
            </v-btn>
          </template>
          <v-btn
            v-else
            color="primary-001"
            dark
            depressed
            @click="closeModalAndLeave"
            class="text-body-2 ml-3"
          >
            {{ $t('CONFIRM') }}
          </v-btn>
        </v-card-actions>
      </template>
    </Modal>
    <Notification
      ref="notification"
    />
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import Input from '@/components/form/Input.vue';
import Textarea from '@/components/form/Textarea.vue';
import MultiAutoComplete from '@/components/form/MultiAutoComplete.vue';
import Modal from '@/components/Modal.vue';
import BreadCrumbs from '@/components/BreadCrumbs.vue';
import defaultReplyApi from '@/restapis/defaultReply';
import TextareaEditor from '@/components/form/TextareaEditor.vue';
import LabelsComboBox from './components/LabelsComboBox.vue';
import DragPhoto from './components/DragPhoto.vue';
import ImagePreview from './components/ImagePreview.vue';
import VideoPreview from './components/VideoPreview.vue';

// api

export default {
  name: 'SavedReply',
  metaInfo: {
    title: 'Saved Reply - Omnichat Admin Panel'
  },
  components: {
    BreadCrumbs,
    Input,
    Textarea,
    MultiAutoComplete,
    LabelsComboBox,
    Modal,
    DragPhoto,
    ImagePreview,
    VideoPreview,
    TextareaEditor
  },
  data() {
    return {
      labels: [],
      valid: true,
      isSubmitLoading: false,
      replyId: '',
      modalType: '',
      temp: {
        title: '',
        content: '',
        target: 1
      },
      pageStatus: '',
      roleSelect: [
      ],
      locationSelect: [
      ],
      images: [],
      shopLocationList: [],
      mediaList: []
    };
  },
  computed: {
    ...mapState({
      currentUserDict: (state) => state.currentUserDict
    }),
    roleList() {
      return [
        {
          title: this.$t('DEFAULT_REPLY.ROLE_MANAGER'),
          value: 5
        },
        {
          title: this.$t('DEFAULT_REPLY.ROLE_CS'),
          value: 2
        },
        {
          title: this.$t('DEFAULT_REPLY.ROLE_CS_MANAGER'),
          value: 4
        },
        {
          title: this.$t('DEFAULT_REPLY.ROLE_MARKETING'),
          value: 3
        },
        {
          title: this.$t('DEFAULT_REPLY.ROLE_SALESPERSON'),
          value: 6
        },
        {
          title: this.$t('DEFAULT_REPLY.ROLE_SALES_MANAGER'),
          value: 7
        }
      ];
    },
    isSalesRole() {
      return !!(this.currentUserDict.role === 6 || this.currentUserDict.role === 7);
    },
    isShowRoleRadio() {
      if (!this.isSalesRole) return true;
      // if (this.currentUserDict.enableOmo) return true;
      return false;
    },
    defaultReplyBreadcrumbs() {
      let title = this.$t('DEFAULT_REPLY.ADD_A_DEFAULT_REPLY');
      if (this.pageStatus === 'update') {
        title = this.temp.title;
      }
      return [
        {
          text: this.$t('DEFAULT_REPLY.DEFAULT_REPLY_MANAGEMENT'),
          disabled: false,
          to: { name: 'SavedReplyDashboard' }
        },
        {
          text: title,
          disabled: true,
          href: ''
        }
      ];
    },
    messagesTotal() {
      const textNum = this.temp.content.trim().length === 0 ? 0 : 1;
      const imageTotal = this.mediaList.length;
      return textNum + imageTotal;
    },
    disabledContentInput() {
      const imageTotal = this.mediaList.length;
      return imageTotal === 5;
    },
    isHideUploadInput() {
      return this.messagesTotal === 5;
    },
    isImageLoadError() {
      let isLoadingError = false;
      if (this.images.length === 0) return false;
      for (let i = 0; i < this.images.length; i += 1) {
        const imgObj = new Image();
        imgObj.src = this.images[i];
        if (imgObj.fileSize > 0 || (imgObj.width > 0 && imgObj.height > 0)) return isLoadingError;
        isLoadingError = true;
        break;
      }
      return isLoadingError;
    }
  },
  watch: {},
  methods: {
    async fetchDefaultReply(id) {
      try {
        const response = await defaultReplyApi.getDefaultReply(id);
        if (response.status === 200) {
          const replyData = response.data.content;
          this.temp.title = replyData.title;
          this.temp.content = replyData.content;
          this.temp.target = replyData.target;
          if (replyData.labels && replyData.labels.length !== 0) {
            this.labels = replyData.labels;
          }
          if (replyData.target === 3) {
            this.roleSelect = replyData.targetRoles;
          }
          if (replyData.target === 4) {
            this.locationSelect = replyData.targetLocationCodes;
          }
          if (replyData.images && replyData.images !== 0) {
            replyData.images.forEach((image) => {
              this.mediaList.push({ mediaType: 'image', url: image });
            });
          }
          if (replyData.videos && replyData.videos !== 0) {
            replyData.videos.forEach((video) => {
              this.mediaList.push({ mediaType: 'video', url: video.videoUrl, previewUrl: video.videoPreviewUrl });
            });
          }
        }
      } catch (error) {
        if (error.response.status === 404) {
          const notificationObj = {
            title: this.$t('DEFAULT_REPLY.NO_DEFAULT_REPLY')
          };
          this.$refs.notification.openNotification(notificationObj);
          setTimeout(() => {
            this.$router.push({ name: 'SavedReplyDashboard' });
          }, 2000);
        }
      }
    },
    async fetchAllShopListListData() {
      this.isLoadingTable = true;
      try {
        const { data } = await defaultReplyApi.getAllShopList();

        this.shopLocationList = data.content;

        this.isLoadingTable = false;
        this.$store.commit('loader/showLoader', false);
      } catch (error) {
        const notificationObj = {
          title: this.$t('DEFAULT_REPLY.FAILED_TO_GET_DEFAULT_REPLY_LIST')
        };
        this.$refs.notification.openNotification(notificationObj);

        this.isLoadingTable = false;
        this.$store.commit('loader/showLoader', false);
      }
    },
    composeDefaultReply() {
      const data = { ...this.temp, images: [], videos: [] };
      if (this.labels.length > 0) {
        data.labels = this.labels;
      }
      if (data.target === 3) {
        data.targetRoles = this.roleSelect;
      }
      if (data.target === 4) {
        data.targetLocationCodes = this.locationSelect;
      }

      this.mediaList.forEach((media) => {
        if (media.mediaType === 'image') {
          data.images.push(media.url);
        } else {
          data.videos.push({ videoUrl: media.url, videoPreviewUrl: media.previewUrl });
        }
      });

      return data;
    },
    checkFormValidate() {
      if (!this.$refs.form.validate()) {
        const notificationObj = {
          title: this.$t('DEFAULT_REPLY.PLEASE_CHECK_ALL_REQUIRED_FIELDS_ARE_COMPLETED')
        };
        this.$refs.notification.openNotification(notificationObj);
        this.isSubmitLoading = false;
        return false;
      }
      if (this.temp.content === '' && this.mediaList.length === 0) {
        const notificationObj = {
          title: this.$t('DEFAULT_REPLY.NO_SET_CONTENT_OR_IMAGE')
        };
        this.$refs.notification.openNotification(notificationObj);
        this.isSubmitLoading = false;
        return false;
      }
      return true;
    },
    async createDefaultReply() {
      this.isSubmitLoading = true;
      if (!this.checkFormValidate()) return;
      try {
        const defaultReplyData = this.composeDefaultReply();
        const response = await defaultReplyApi.createDefaultReply(defaultReplyData);
        if (response.status === 200) {
          this.isSubmitLoading = false;
          this.openCheckModal(this.pageStatus);
        }
      } catch (error) {
        const notificationObj = {
          title: this.$t('DEFAULT_REPLY.ADD_FAILED_PLEASE_TRY_AGAIN_LATER')
        };
        this.$refs.notification.openNotification(notificationObj);
        this.isSubmitLoading = false;
      }
    },
    async updateDefaultReply() {
      this.isSubmitLoading = true;
      if (!this.checkFormValidate()) return;
      try {
        const defaultReplyData = this.composeDefaultReply();

        const response = await defaultReplyApi.updateDefaultReply(this.replyId, defaultReplyData);
        if (response.status === 204) {
          this.isSubmitLoading = false;
          this.openCheckModal(this.pageStatus);
        }
      } catch (error) {
        const notificationObj = {
          title: this.$t('DEFAULT_REPLY.UPDATE_FAILED_PLEASE_TRY_AGAIN_LATER')
        };
        this.$refs.notification.openNotification(notificationObj);
        this.isSubmitLoading = false;
      }
    },
    openCheckModal(modalType) {
      this.modalType = modalType;
      let title = '';
      let content = '';
      switch (modalType) {
        case 'cancel':
          title = this.$t('ARE_YOU_SURE_TO_LEAVE_THE_PAGE');
          content = this.$t('DEFAULT_REPLY.LEAVE_PAGE_DATA_WILL_BE_LOST');
          break;
        case 'update':
          title = this.$t('DEFAULT_REPLY.DEFAULT_REPLY_UPDATE_SUCCESS');
          break;
        case 'create':
          title = this.$t('DEFAULT_REPLY.DEFAULT_REPLY_CREATE_SUCCESS');
          break;
        default:
          title = '';
          break;
      }
      this.$refs.checkModal.openModal(title, content);
    },
    closeModalAndLeave() {
      this.$refs.checkModal.closeModal();
      this.$router.push({ name: 'SavedReplyDashboard' });
    },
    updateLabels(tag) {
      this.labels = tag;
    },
    comboboxRule(value) {
      if (value instanceof Array && value.length === 0) {
        return this.$t('DEFAULT_REPLY.THIS_FIELD_IS_REQUIRED');
      }
      return !!value || this.$t('DEFAULT_REPLY.THIS_FIELD_IS_REQUIRED');
    },
    addImgUrl(val) {
      console.log('addImgUrl');
      console.log(val);
      this.images.push(val);
    },
    addMedia(val) {
      console.log(val);
      this.mediaList.push(val);
    },
    updateMedia(mediaObj, index) {
      this.$set(this.mediaList, index, mediaObj);
    },
    deleteMediaItem(imageIndex) {
      console.log('delete');
      this.mediaList.splice(imageIndex, 1);
    },
    getMediaComponent(type) {
      return type === 'image' ? ImagePreview : VideoPreview;
    }
  },
  async mounted() {
    this.$store.commit('loader/showLoader', true);
    await this.fetchAllShopListListData();
    if (this.$route.params.id) {
      this.pageStatus = 'update';
      this.replyId = this.$route.params.id;
      this.$store.commit('loader/showLoader', true);
      await this.fetchDefaultReply(this.replyId);
    } else {
      this.pageStatus = 'create';
    }
    setTimeout(() => {
      this.$store.commit('loader/showLoader', false);
    }, 300);
  }
};
</script>

<style lang="scss" scoped>
::v-deep.default-reply-header {
  padding: 0 50px;
  .v-toolbar__content {
    padding-left: 0;
    padding-right: 0;
  }
}

::v-deep.cancel-btn {
  .v-btn__content {
    color: $neutral-cold-051;
  }
}

.mt-43{
  margin-top: 43px;
}

.default-reply-warp{
  padding: 50px 35px 50px 50px;
}

.default-reply-title {
  margin-bottom: 32px;
}

.labels-combo-box {
  margin-top: 16px;
}

.content-col {
  width: calc(50% - 20px)
}

.photo-row {
  margin: -12px -8px;
}

::v-deep .target-radio-box {
  .v-input--selection-controls {
    padding-top: 0;
  }

  .v-input--radio-group > .v-input__control > .v-messages {
    display: none;
  }

  .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
    margin-bottom: 12px;
  }
}

.target-radio-auto-complete {
  margin-left: 31px;
}

.photo-container {
  margin-top: 6px;
  .photo-title {
    margin-bottom: 14px;
  }
}

.image-card {
  border-radius: 4px;
  border: 1px $neutral-cold-054 dashed;
  padding: 2px;
}
.custom-btn-wrapper {
  margin-top: -12px;
}
.custom-attribute {
  height: 100%;
}
.custom-btn {
  font-size: 16px;
  line-height: 24px;
}
</style>
